import { toast } from "react-toastify"
import 'react-toastify/dist/ReactToastify.css';

export function MiToast() {
    return(
    toast.error("Error en la carga, intente nuevamnete", {
        position: "top-center",
        autoClose: 5000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        hideProgressBar: true
    })
    )
}